module.exports = __webpack_public_path__ + "img/woody_hero_desktop.3d98b479.jpg";